import { Target } from "lucide-react";
import { Card } from "@/components/common/PageHeader";

export function ActionPlan({ actions = [], title = "Your personalized action plan" }) {
  const total = actions.reduce((s, a) => s + (a.points || 0), 0);
  return (
    <Card className="p-5" data-testid="action-plan">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#b0862f]/10"><Target size={17} className="text-[#b0862f]" /></div>
          <div>
            <div className="font-head text-[15px] font-bold text-slate-900">{title}</div>
            <div className="font-mono text-[10px] uppercase tracking-wider text-slate-400">Do these {actions.length} things</div>
          </div>
        </div>
        {total > 0 && <span className="rounded-lg bg-emerald-50 px-2.5 py-1 font-mono text-[12px] font-bold text-emerald-600">&rarr; +{total} pts</span>}
      </div>
      <div className="space-y-2.5">
        {actions.map((a, i) => (
          <div key={a.title} className="flex items-start gap-3 rounded-xl border border-slate-100 px-4 py-3" data-testid="action-plan-item">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#1a5fd0] font-head text-[13px] font-bold text-white">{i + 1}</span>
            <div className="flex-1">
              <div className="text-[13px] font-semibold text-slate-800">{a.title}</div>
              {a.detail && <div className="mt-0.5 text-[12px] text-slate-500">{a.detail}</div>}
            </div>
            {a.points > 0 && <span className="shrink-0 rounded-md bg-emerald-50 px-1.5 py-0.5 font-mono text-[11px] font-bold text-emerald-600">+{a.points}</span>}
          </div>
        ))}
      </div>
    </Card>
  );
}
